export default "__VITE_ASSET__Dg$duoww__"